import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../components/tabs/langController";

// labels
import {FL_DESCRIPTION, FL_HORARIO, FL_PRESENTATION, FL_TITLE, FL_WARNING} from "../../../components/i18n/formLabels";
import {PH_DESCRIPTION, PH_HORARIO, PH_PRESENTATION, PH_TITLE, PH_WARNING} from "../../../components/i18n/placeHolders";

const DestinationActivityLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            title: '',
            schedule: '',
            presentation: '',
            description: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={PH_TITLE}
                        value= { child.title }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"6"}>
                <FormGroup>
                    <Label>{FL_HORARIO}</Label>
                    <Input
                        type="text"
                        name="schedule"
                        placeholder={PH_HORARIO}
                        value= { child.schedule }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"6"}>
                <FormGroup>
                    <Label>{FL_PRESENTATION}</Label>
                    <Input
                        type="text"
                        name="presentation"
                        placeholder={PH_PRESENTATION}
                        value= { child.presentation }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        rows="8"
                        name="description"
                        placeholder={PH_DESCRIPTION}
                        value= { child.description }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default DestinationActivityLangs




/*
import React from 'react';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import {langService} from "../../../jwt/_services";
import LangTab from "../../../components/tabs/langTab";
import {showLoader} from "../../../components/loader/loader";
import {langDestinationActivityService} from "../../../jwt/_services/xailing/langDestinationActivityService";


class DestinationActivityLangs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: this.props.editMode,
            disableInputs : this.props.disableInputs,
            loading: false,

            destinationActivity : this.props.destinationActivity,
            langChilds: [],
            langDestinationActivityChilds: []
        }

        this.setForm = this.setForm.bind(this);
        this.combineLangChilds = this.combineLangChilds.bind(this);
        this.getLangChilds = this.getLangChilds.bind(this);
        this.getFormulary = this.getFormulary.bind(this);
        this.updateParent = this.updateParent.bind(this);

        this.onTitleChange = this.onTitleChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onScheduleChange = this.onScheduleChange.bind(this);
    }

    componentDidMount() {
        // ----------------------------------
        // Establece las opciones de idioma
        // ----------------------------------
        let langChilds = [];
        this.setState({loading: true});
        langService.getAll()
            .then(langOptions => {
                if (langOptions) {
                    langOptions.map((lang, _) => {
                        const langChild = {
                            lang: lang,
                            id: '',

                            title: '',
                            presentation: '',
                            description: '',
                            schedule: '',
                        };
                        langChilds.push(langChild);
                        this.setState({langChilds, loading: false});
                    });
                } else {
                    this.setState({loading: false});
                }
            })
            .then( () => {
                // ----------------------------------
                // Consulta los idiomas guardados
                // ----------------------------------
                if (this.state.editMode){
                    this.setState({loading: true});
                    langDestinationActivityService.search({id: this.state.destinationActivity?.id})
                        .then((langDestinationActivityChilds) => {
                            if (langDestinationActivityChilds) {
                                this.setState({langDestinationActivityChilds});
                            }
                        })
                        .then(() => {
                            if (this.state.langDestinationActivityChilds && this.state.langDestinationActivityChilds.length > 0){
                                langChilds = this.combineLangChilds(this.state.langChilds, this.state.langDestinationActivityChilds);
                                this.setState({langChilds, loading: false});
                            }else {
                                this.setState({loading: false});
                            }
                        })
                }
            });
    }

    setForm(editMode, showList, data) {
        this.props.setForm(editMode, showList, data)
    }

    getLangChilds(){
        const langChilds = this.combineLangChilds(this.state?.langChilds, this.state?.langDestinationActivityChilds);
        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(option){
        this.setState({disableInputs : option });
        this.getLangChilds(); // Refresh component
    }

    resetForm(){
        let langOption = [];
        this.state.langChilds.map((langC) => {
            const langChild = {
                lang: langC.lang,
                id: '',

                title: '',
                presentation: '',
                description: '',
                schedule: '',
            };
            langOption.push(langChild);
        });
        this.setState({langChilds: langOption, langDestinationActivityChilds: [], disableInputs : false});
        this.getLangChilds();
    }

    combineLangChilds(langOptions, langDestinationActivityChilds){
        try {
            if (langOptions && langDestinationActivityChilds && langOptions.length > 0 && langDestinationActivityChilds.length > 0){
                langOptions.map((child, index) => {
                    const langTagIndex = langDestinationActivityChilds.findIndex(n => n.lang.id === child.lang.id);

                    if (langTagIndex !== -1) {
                        // significa que si lo encontro
                        langOptions[index] = {
                            lang :  langDestinationActivityChilds[langTagIndex].lang,
                            uid :  langDestinationActivityChilds[langTagIndex].uid,
                            id :    langDestinationActivityChilds[langTagIndex].id,

                            title :  langDestinationActivityChilds[langTagIndex].title,
                            presentation :  langDestinationActivityChilds[langTagIndex].presentation,
                            description :  langDestinationActivityChilds[langTagIndex].description,
                            schedule :  langDestinationActivityChilds[langTagIndex].schedule,
                        }
                    }
                });
                return langOptions;
            }
        } catch (e) {
            return e.message;
        }
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    onTitleChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            id : langChilds[langIndex].id,
            uid : langChilds[langIndex].uid,

            title :  value,
            presentation :  langChilds[langIndex].presentation,
            description :  langChilds[langIndex].description,
            schedule :  langChilds[langIndex].schedule,
        }

        this.updateParent(langChilds);
    }

    onPresentationChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            id : langChilds[langIndex].id,
            uid : langChilds[langIndex].uid,

            title :  langChilds[langIndex].title,
            presentation : value,
            description :  langChilds[langIndex].description,
            schedule :  langChilds[langIndex].schedule,
        }

        this.updateParent(langChilds);
    }

    onDescriptionChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            id : langChilds[langIndex].id,
            uid : langChilds[langIndex].uid,

            title :  langChilds[langIndex].title,
            presentation :  langChilds[langIndex].presentation,
            description :  value,
            schedule :  langChilds[langIndex].schedule,
        }

        this.updateParent(langChilds);
    }

    onScheduleChange(value, index, lang){
        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            id : langChilds[langIndex].id,
            uid : langChilds[langIndex].uid,

            title :  langChilds[langIndex].title,
            presentation :  langChilds[langIndex].presentation,
            description :  langChilds[langIndex].description,
            schedule :  value,
        }

        this.updateParent(langChilds);
    }

    updateParent(langChilds){
        this.props.updateItem(langChilds);
        this.setState({
            langChilds : langChilds,
            langDestinationActivityChilds : langChilds
        });
    }

    getFormulary(child, index, disableInputs){
        return (
            <Form>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Nombre</Label>
                            <Input type="text" name="title"
                                   placeholder="Ingrese titulo"
                                   value= { child.title }
                                   onChange={e => this.onTitleChange(e.target.value, index, child.lang )}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Horario</Label>
                            <Input type="text" name="schedule"
                                   placeholder="Ingrese horario"
                                   value= { child.schedule }
                                   onChange={e => this.onScheduleChange(e.target.value, index, child.lang )}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Presentación</Label>
                            <Input type="text" name="presentation"
                                   placeholder="Ingrese presentación"
                                   value= { child.presentation }
                                   onChange={e => this.onPresentationChange(e.target.value, index, child.lang )}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Descripción</Label>
                            <Input type="textarea" name="description"
                                   placeholder="Ingrese descripción"
                                   rows="5"
                                   value= { child.description }
                                   onChange={e => this.onDescriptionChange(e.target.value, index, child.lang )}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

    render() {
        return (
            <div>
                <Row>
                    {this.state.loading ? showLoader() : null}
                    <Col md="12">
                        <LangTab
                            key={"LangId"}
                            langChilds={this.state.langChilds}
                            getLangChilds={this.getLangChilds}
                            getFormulary={this.getFormulary}
                            disableInputs={this.state.disableInputs}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default DestinationActivityLangs;

*/